// valid support states
const STATES = ['', 'error', 'success', 'disabled'];

const arrayIncludes = (array, value) => array.indexOf(value) !== -1;

export default {
  name: 'MInputDollar',
  props: {
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: [String, Number],
    type: {
      type: String,
      default: 'text',
    },
    state: {
      type: String,
      default: '',
      validator: state => arrayIncludes(STATES, state),
    },
  },
  computed: {
    localState() {
      return arrayIncludes(STATES, this.state) ? this.state : '';
    },
    mask() {
      return {
        numeral: true,
        numeralDecimalMark: '.',
        numeralDecimalScale: 2,
        numeralThousandsGroupStyle: 'thousand',
      };
    },
  },
};
